
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b",
      function () {
        return require("private-next-pages/b.js");
      }
    ]);
  